import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider, type RouteObject } from 'react-router-dom';
import { ToastProvider } from '../lib/toasts';
import { routes } from './routes';

export function createQueryClient(): QueryClient {
  return new QueryClient({ defaultOptions: { queries: { staleTime: 30_000 } } });
}

/** Root component: data layer and router. */
export function App({
  queryClient = createQueryClient(),
  appRoutes = routes,
}: {
  queryClient?: QueryClient;
  appRoutes?: RouteObject[];
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={createBrowserRouter(appRoutes)} />
      </ToastProvider>
    </QueryClientProvider>
  );
}
